import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { enToHeActivityField } from '../../utils/activityFieldsDict';
import { enToHePopulation } from '../../utils/populationDict';
import { getCrmImageUrl } from '../../utils/imageUrl';
import './Project.css';

export default function Project(props) {

    let project = props.project_fields;
    const [isLiked, setIsLiked] = useState(false);

    // Check if project is liked on mount
    useEffect(() => {
        const likedProjects = JSON.parse(localStorage.getItem('likedProjects')) || [];
        setIsLiked(likedProjects.includes(project._id));
    }, [project._id]);

    const toggleLike = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const likedProjects = JSON.parse(localStorage.getItem('likedProjects')) || [];
        let updatedLikedProjects;

        if (isLiked) {
            // Remove from liked projects
            updatedLikedProjects = likedProjects.filter(id => id !== project._id);
        } else {
            // Add to liked projects
            updatedLikedProjects = [...likedProjects, project._id];
        }

        localStorage.setItem('likedProjects', JSON.stringify(updatedLikedProjects));
        setIsLiked(!isLiked);

        // Dispatch custom event to notify Header component
        window.dispatchEvent(new Event('likedProjectsUpdated'));
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}.${month}.${year}`;
    };

    const truncateDescription = (text, maxWords = 23) => {
        if (!text) return '';
        const words = text.split(' ');
        if (words.length <= maxWords) return text;
        return words.slice(0, maxWords).join(' ') + '...';
    };
    const isFullyAssigned = project.assignmentStatus === 'fully' || project.assignmentStatus === 'closed';

  return (
    <div className="card-container">
        <div className={`card ${isFullyAssigned ? 'fully-assigned' : ''}`}>
            <div>
                <div className="card-img">
                    {
                        project.image ?
                        <img src={getCrmImageUrl(project.image)} alt={'image'} aria-hidden="true"/> :
                        <div className="placeholder image"></div>
                    }
                    {isFullyAssigned && (
                        <h3 className="badge badge-full">הפעילות מלאה</h3>
                    )}
                </div>
                <div className="card-title-wrapper">
                    <h4>{project.name}</h4>
                    {/* <div className="title-separator"></div> */}
                </div>
                <div className="card-info-item working-mode"> 
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16">
                        <g fill="#B50072" fillRule="nonzero">
                            <path d="M.527 13h13.795a.51.51 0 0 0 .339-.13C14.793 12.752 17.816 9.98 18 4H3.184C3 9.429.217 11.98.188 12.006a.588.588 0 0 0-.156.624.53.53 0 0 0 .495.37zM17.466 1h-2.673V.5c0-.28-.235-.5-.534-.5-.3 0-.535.22-.535.5V1h-2.707V.5c0-.28-.236-.5-.535-.5-.3 0-.534.22-.534.5V1H7.276V.5c0-.28-.236-.5-.535-.5-.3 0-.534.22-.534.5V1H3.534C3.235 1 3 1.22 3 1.5V3h15V1.5c0-.28-.235-.5-.534-.5z" />
                            <path d="M15.288 13.691c-.29.222-.655.343-1.03.343H3v1.475c0 .271.239.491.534.491h13.932c.295 0 .534-.22.534-.491V10c-1.03 2.324-2.468 3.503-2.712 3.691z" />
                        </g>
                    </svg>
                    <p>{formatDate(project.date)}</p>
                </div>
                {/* <div className="card-description-wrapper">
                    <p className="card-description">{project.parentOrganizationTitle || project.attributes.externalOrganizationName}</p>
                </div> */}
                <div className="card-info-item card-location"> 
                    <svg className="location-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="22" viewBox="0 0 16 22" fill="#000000">
                        <path d="M7.997 10.481c-1.773 0-3.215-1.415-3.215-3.153 0-1.74 1.442-3.154 3.215-3.154 1.772 0 3.214 1.415 3.214 3.154 0 1.738-1.442 3.153-3.214 3.153m0-10.46C3.587.02 0 3.54 0 7.866c0 2.695 3.337 8.617 6.136 13.11A2.176 2.176 0 007.996 22c.766 0 1.462-.383 1.861-1.024 2.8-4.493 6.136-10.415 6.136-13.11 0-4.326-3.587-7.845-7.996-7.845" fillRule="evenodd"></path>
                    </svg>
                    <p data-default-text="מיקום">
                    {/* {
                        project?.addresses?.map((item, index) => {
                            return  index < 10 && <span key={index}>{(index > 0 && index !== project.addresses.length) ? ", " : ""}{item.cityTitle}</span>
                        })
                    } */}
                    {project.address?.city?.name}
                    </p>
                </div>
                <div className="card-info-item vacancies"> 
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16">
                        <g fill="#000000" fillRule="nonzero">
                            <circle cx="9" cy="3" r="3" />
                            <circle cx="16" cy="4" r="2" />
                            <circle cx="3" cy="4" r="2" />
                            <path d="M4 8.526c-.645-.602-1.23-.523-1.976-.523C.908 8.003 0 9.031 0 10.293V14c0 .548.393.994.877.994 2.087 0 1.836.043 1.836-.102 0-2.626-.274-4.552 1.287-6.366zM9.891 7.044c-1.614-.137-3.016.002-4.226 1.019-2.025 1.65-1.635 3.874-1.635 6.593 0 .72.575 1.316 1.293 1.316 7.79 0 8.1.256 8.562-.785.151-.353.11-.24.11-3.61 0-2.677-2.276-4.533-4.104-4.533zM15.976 8.003c-.75 0-1.332-.078-1.976.523 1.549 1.8 1.287 3.594 1.287 6.365 0 .147-.208.103 1.805.103.5 0 .908-.462.908-1.03v-3.67c0-1.263-.908-2.29-2.024-2.29z" />
                        </g>
                    </svg>
                    <p>{project.shifts?.reduce((sum, shift) => sum + (shift.availablePlaces || 0), 0) || 0} מקומות נותרו</p>
                </div>
                <div className="card-info-item activityfield"> 
                    <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.10884 14.6973L0.663265 10.5646C0.238095 10.0544 0 9.38435 0 8.68027V1.63265C0 0.734694 0.639456 0.00340136 1.42517 0H1.42857C1.77551 0 2.10884 0.142857 2.37075 0.404762C2.68367 0.714286 2.86054 1.16327 2.86054 1.63265V6.4898C2.35034 7.18367 2.38775 8.21089 2.97279 8.85714L5.19048 11.3129C5.35034 11.4898 5.62585 11.5068 5.80272 11.3435C5.97959 11.1837 5.9966 10.9082 5.83333 10.7313L3.61565 8.27551C3.28912 7.91156 3.28912 7.29932 3.61565 6.93537C3.61565 6.93537 3.61565 6.93537 3.61905 6.93197C3.76871 6.76871 3.95918 6.67687 4.16327 6.67687C4.36735 6.67687 4.56122 6.76871 4.70748 6.93197L8.77891 11.4422C9.28231 12 9.56803 12.7721 9.56803 13.5646V13.5714V18.7755H5.03061V17.2857C5.03061 16.3299 4.70408 15.4082 4.10884 14.6973ZM20 8.69728C20 9.39796 19.7653 10.0646 19.3401 10.5782L15.8946 14.7041C15.3027 15.415 14.9762 16.3333 14.9762 17.2959V18.7823H10.4422V13.5782C10.4422 12.7857 10.7313 12.0136 11.2313 11.4592L15.2959 6.95578C15.5918 6.62925 16.0884 6.62925 16.3844 6.95578C16.7109 7.31973 16.7109 7.93197 16.3844 8.29252L14.1701 10.7449C14.0102 10.9218 14.0238 11.1973 14.2007 11.3571C14.3776 11.517 14.6531 11.5034 14.8129 11.3265L17.0272 8.87415C17.6088 8.22789 17.6463 7.20408 17.1395 6.5068V1.65986C17.1395 1.19048 17.3163 0.741497 17.6293 0.431973C17.8912 0.173469 18.2211 0.0306123 18.568 0.0306123H18.5714C19.3571 0.0340137 19.9966 0.765306 19.9966 1.65986V8.69728H20Z" fill="black"/>
                    </svg>
                    <p>{enToHeActivityField[project.attributes?.activityField] || project.attributes?.activityField}</p>
                </div>
                <div className="card-info-item description"> 
                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M17.5675 14.5181C18.4751 13.0619 19 11.3424 19 9.49963C19 4.25259 14.747 0 9.5 0C4.25296 0 0 4.25259 0 9.49963C0 14.7482 4.25296 19 9.5 19C11.3428 19 13.0627 18.4749 14.5192 17.5669L18.6831 18.6823L17.5675 14.5181ZM9.5 4.43041C10.1585 4.43041 10.6928 4.96431 10.6928 5.62322C10.6928 6.28176 10.1589 6.81603 9.5 6.81603C8.84109 6.81603 8.30719 6.28214 8.30719 5.62322C8.30719 4.96431 8.84146 4.43041 9.5 4.43041ZM7.41267 14.57H11.5873H11.5874V12.7805H10.6928V9.20209V7.41304H7.41267V9.20209H8.30719V12.7805H7.41267V14.57Z" fill="black"/>
                    </svg>
                    <p>{truncateDescription(project.description)}</p>
                </div>
            </div>
            <div>
                <div className={`card-info-item like ${isLiked ? 'liked' : ''}`} onClick={toggleLike}>
                    <svg className="heart-icon" width="20" height="18" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 21.35L10.55 20.03C5.4 15.36 2 12.28 2 8.5C2 5.42 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.09C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.42 22 8.5C22 12.28 18.6 15.36 13.45 20.04L12 21.35Z" stroke="#000000" strokeWidth="1.5" fill="none"/>
                    </svg>
                    <p>מעניין אותי</p>
                </div>
                <div className="card-footer">
                    {isFullyAssigned ? (
                        <span className="btn btn-gray" title="ההתנדבות מלאה">ההתנדבות מלאה</span>
                    ) : (
                        <Link to={`/project/${project._id}`} className="btn btn-blue" title="לפרטים והרשמה לפרויקט">לפרטים ולהתנדבות</Link>
                    )}
                </div>
            </div>
           
        </div>
    </div>
  )
}
